import Joi from "@hapi/joi";

export default {
    dbId: {
        defaultValue: 0,
        validation: Joi.any()
    },
    start: {
        defaultValue: "",
        validation: Joi.any()
            .label("Startzeitpunkt"),
        render: {
            type: "dateTimeInput",
            configuration: {
                label: "Start",
                autofocus: true

            }
        }
    },
    end: {
        defaultValue: "",
        validation: Joi.any()
            .label("Endezeitpunkt"),
        render: {
            type: "dateTimeInput",
            configuration: {
                label: "Ende"
            }
        }
    },
    receiver: {
        company: {
            defaultValue: 0,
            validation: Joi.number()
                .min(1)
                .label("Empfänger"),
            render: {
                type: "selectByList",
                configuration: {
                    label: "Firmenname",
                    // nullable: true
                    // enterValue: true,
                }
            }
        },
        contactPerson: {
            defaultValue: 0,
            validation: Joi.number()
                .min(1)
                .label("Kontaktperson"),
            render: {
                type: "selectByList",
                configuration: {
                    label: "Kontaktperson",
                    nullable: false
                }
            }
        }
    },
    vendor: {
        company: {
            defaultValue: 0,
            validation: Joi.number()
                .min(0)
                .label("Lieferant"),
            render: {
                type: "selectByList",
                configuration: {
                    label: "Firmenname",
                    // nullable: true
                    // enterValue: true,
                }
            }
        },
        contactPerson: {
            defaultValue: 0,
            validation: Joi.number()
                .min(0)
                .label("Kontaktperson"),
            render: {
                type: "selectByList",
                configuration: {
                    label: "Kontaktperson",
                    nullable: false
                }
            }
        },
        iName: {
            defaultValue: "",
            validation: Joi.any()
                .label("Name"),
            render: {
                type: "input",
                configuration: {
                    label: "Firmenname"
                }
            }
        },
        iContactPerson: {
            firstname: {
                defaultValue: "",
                validation: Joi.any()
                    .label("Vorname"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Vorname"
                    }
                }
            },
            surname: {
                defaultValue: "",
                validation: Joi.any()
                    .label("Nachname"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Nachname"
                    }
                }
            },
            mobilePhone: {
                defaultValue: "",
                validation: Joi.any()
                    .label("Mobilenummer"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Mobilnummer"
                    }
                }
            },
            email: {
                defaultValue: "",
                validation: Joi.any()
                    .label("Email"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Email"
                    }
                }
            }
        }
    },
    carrier: {
        company: {
            defaultValue: 0,
            validation: Joi.number()
                .min(0)
                .label("Lieferant"),
            render: {
                type: "selectByList",
                configuration: {
                    label: "Firmenname",
                    // nullable: true
                    // enterValue: true,
                }
            }
        },
        contactPerson: {
            defaultValue: 0,
            validation: Joi.number()
                .min(0)
                .label("Kontaktperson"),
            render: {
                type: "selectByList",
                configuration: {
                    label: "Kontaktperson",
                    nullable: false
                }
            }
        },
        iName: {
            defaultValue: "",
            validation: Joi.any()
                .label("Name"),
            render: {
                type: "input",
                configuration: {
                    label: "Firmenname"
                }
            }
        },
        iContactPerson: {
            firstname: {
                defaultValue: "",
                validation: Joi.any()
                    .label("Vorname"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Vorname"
                    }
                }
            },
            surname: {
                defaultValue: "",
                validation: Joi.any()
                    .label("Nachname"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Nachname"
                    }
                }
            },
            mobilePhone: {
                defaultValue: "",
                validation: Joi.any()
                    .label("Mobilenummer"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Mobilnummer"
                    }
                }
            },
            email: {
                defaultValue: "",
                validation: Joi.any()
                    .label("Email"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Email"
                    }
                }
            }
        }
    },
    vehicles: {
        defaultValue: [],
        validation: Joi.any(),
        // .required()
        // .label("Fahrzeug"),
        render: {
            type: "detailTable1",
        },
        baseInformation: {
            registration: {
                defaultValue: "",
                validation: Joi.string()
                    .required()
                    .label("Kennzeichen"),
                render: {
                    type: "input",
                    configuration: {
                        label: "Kennzeichen"
                    }
                }
            },
            vehicleType: {
                defaultValue: "",
                validation: Joi.string()
                    .required()
                    .label("KFZ-Typ"),
                render: {
                    type: "selectByList",
                    configuration: {
                        label: "KFZ-Typ"
                    }
                }
            }
        }
    },
    ressourcesMap: {
        defaultValue: {},
        validation: Joi.any(),
        // .required()
        // .label("Ressource"),
        render: {
            type: "multiSelectCheckbox",
            configuration: {
                label: ""
                // nullable: false,
                // enterValue: true,
            }
        }
    },
    loadingPlacesMap: {
        defaultValue: {},
        validation: Joi.any(),
        // .required()
        // .label("Abladeplatz"),
        render: {
            type: "multiSelectCheckbox",
            configuration: {
                label: ""
            }
        }
    }
}